export default __webpack_public_path__ + "static/media/pantry1-afterH-768w.a9df8e83.avif";